import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Table from '../Listing/Table';
import LaboratoryLogo from '../Laboratory/LaboratoryLogo';

const formatAmount = (val) =>
    new Intl.NumberFormat('fr-MA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val ?? 0);

const AmountCell = ({ value, highlight }) => (
    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'flex-end', gap: 4 }}>
        <span style={{
            fontSize: 14, fontWeight: 700,
            color: highlight ? '#059669' : '#111827',
        }}>
            {formatAmount(value)}
        </span>
        <span style={{ fontSize: 11, color: '#9ca3af', fontWeight: 500 }}>dhs</span>
    </div>
);

const getOrderablePath = (orderable) => {
    const type = orderable?.type?.toLowerCase();
    if (type === 'product') return `/products/${orderable.id}`;
    return null;
};

const OrderItems = ({ items }) => {
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('desc');

    const columns = [
        {
            Header: '#',
            accessor: 'id',
            sortable: true,
            Cell: (row) => (
                <span style={{ fontSize: 13, fontWeight: 500, color: '#9ca3af' }}>
                    {row.id}
                </span>
            ),
        },
        {
            Header: 'Article',
            sortable: true,
            Cell: (row) => {
                const path = getOrderablePath(row?.orderable);
                const sub = [row?.orderable?.presentation, row?.orderable?.dosage].filter(Boolean).join(' · ');
                return (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            {path
                                ? <NavLink to={path} className="cell-name">{row?.orderable?.name}</NavLink>
                                : <span className="cell-name" style={{ color: '#111827' }}>{row?.orderable?.name}</span>
                            }
                        </div>
                        {sub && (
                            <span className="cell-sub" style={{ color: '#111827' }}>{sub}</span>
                        )}
                        {row?.orderable?.laboratoryName && (
                            <NavLink
                                to={`/suppliers/${row.orderable.laboratoryId}`}
                                className="cell-sub"
                                style={{ textDecoration: 'none', color: '#374151', display: 'flex', alignItems: 'center', gap: 6, marginTop: 5 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                Par <LaboratoryLogo id={row.orderable.laboratoryId} name={row.orderable.laboratoryName} size={16} />
                                {row.orderable.laboratoryName}
                            </NavLink>
                        )}
                    </div>
                );
            },
        },
        {
            Header: 'Prix unitaire',
            className: 'text-end',
            Cell: (row) => <AmountCell value={row.unitPrice} />,
        },
        {
            Header: 'Qté',
            accessor: 'quantity',
            className: 'text-center',
            Cell: (row) => (
                <span style={{
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    minWidth: 32, height: 26,
                    background: '#f3f4f6', borderRadius: 8,
                    fontSize: 13, fontWeight: 700, color: '#374151',
                    padding: '0 10px',
                }}>
                    {row.quantity}
                </span>
            ),
        },
        {
            Header: 'Total',
            className: 'text-end',
            Cell: (row) => <AmountCell value={row.unitPrice * row.quantity} highlight />,
        },
    ];

    return (
        <Table
            mode="client"
            columns={columns}
            data={items}
            emptyMessage="Aucun article"
            onSort={(field) => {
                setSortField(field);
                setSortDirection((prev) => (sortField === field && prev === 'asc' ? 'desc' : 'asc'));
            }}
            sortField={sortField}
            sortDirection={sortDirection}
            totalElements={items?.length ?? 0}
        />
    );
};

export default OrderItems;
